<template>
  <div>
    <b-card class="mb-3">
      <b-row class="align-items-end">
        <b-col md="3">
          <b-form-group label="Data Inicial">
            <b-form-input
              id="initial-date"
              v-model="initialDate"
              type="date"
              :max="maxAllowedDate"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="Data Final">
            <b-form-input
              id="final-date"
              v-model="finalDate"
              type="date"
              :max="maxAllowedDate"
            />
          </b-form-group>
        </b-col>

        <b-col md="2" class="mb-1">
          <b-button
            variant="primary"
            class="w-100 d-flex align-items-center justify-content-center"
            @click="handleSearch"
            :disabled="isLoading"
          >
            <div v-if="isLoading" class="dotted-spinner"></div>
            <span v-else>Buscar</span>
          </b-button>
        </b-col>

        <b-col md="3" class="mb-1">
          <b-button
            id="btn-enviar"
            class="w-100 d-flex align-items-center justify-content-center"
            @click="openConfirmModal"
            :disabled="sendingArchives"
          >
            <div v-if="sendingArchives" class="dotted-spinner"></div>
            <span v-else>Enviar arquivos manualmente</span>
          </b-button>
        </b-col>

        <b-col md="1" class="d-flex justify-content-end mb-2">
          <b-button class="tour-icon-btn" @click="startTour">
            <i class="fas fa-question"></i>
          </b-button>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-center">
          <p v-if="searchError" class="search-error">{{ searchError }}</p>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col md="3">
        <Summary
          :pix="pix"
          :veripag="veripag"
          :ediRede="ediRede"
          :pending="pending"
          :gateway="gateway"
          :gatewayData="gatewayData"
          :isExporting="isExporting"
          :initialDate="initialDate"
          :finalDate="finalDate"
          @open-table="openTable"
          @export-excel="generateExcelStyled"
        />
      </b-col>

      <b-col md="4" id="receipt-area">
        <Receipt
          :receiptData="receiptData"
          type="transaction"
          @open-table="openTable"
        />
      </b-col>

  <b-col md="5">
        <DataTable
          v-if="selectedTable"
          :visible="true"
          :title="selectedTable"
          ref="dataTable"
          :tableData="tableContent"
          @open-not-conciliated="openNotConciliated"
          @row-selected="openTransactionDetails"
          @back-to-resume="backToResume"
        />

  <div v-else class="no-table-selected d-flex align-items-center justify-content-center">
    <div class="text-center">
      <i class="fas fa-table fa-2x mb-2" aria-hidden="true"></i>
      <h5 class="mb-1">Nenhuma tabela selecionada</h5>
      <p class="mb-0">Selecione um resumo à esquerda para visualizar os detalhes aqui.</p>
    </div>
  </div>

  <TransactionDetailsModal
    modal-id="details-modal"
    :data="selectedTransaction"
  />
</b-col>
    </b-row>
        <b-modal
        id="confirm-check-modal"
        title="Confirmar Ação"
        centered
        @ok="confirmSendFiles"
        ok-title="Confirmar"
        cancel-title="Cancelar"
      >
        Tem certeza que deseja enviar os arquivos de conciliação manualmente?
      </b-modal>

  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormInput,
  BFormGroup,
  BSpinner,
  BModal,
} from "bootstrap-vue";
import Summary from "./Summary.vue";
import Receipt from "./Receipt.vue";
import DataTable from "./DataTable.vue";
import TransactionDetailsModal from "./TransactionDetailsModal.vue";
import { startDashboardTour } from "@/utils/conciliationGuide.js";
import ConciliationEdiRedeService from "@/service/conciliation-edi-rede";
import { generateConciliationExcel} from "@/utils/exportExcelConciliation";

function getYesterdayDate() {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date.toISOString().split("T")[0];
}

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BSpinner,
    BModal,
    Summary,
    Receipt,
    DataTable,
    TransactionDetailsModal,
  },
  data() {
    return {
      pix: null,
      pixResume: [],
      pixNotConciliatedVeripag: [],
      pixNotConciliatedItau: [],
      pixNotConciliatedGsurf: [],
      selectedTransaction: null,
      sendingArchives:false,
      isExporting: false,
      veripagResume: [],
      ediRedeResume: [],
      othersStatusResume: [],
      gsurfRaw: null,
      paygoRaw: null,
      gsurfResume: [],
      paygoResume: [],
      gsurfNotConciliated: [],
      paygoNotConciliated: [],
      isLoading: false,
      searchError: null,
      processingRaw: null,
      processingResume: [],
      processingTransactions: [],
      veripagNotConciliated: [],
      ediRedeNotConciliated: [],
      initialDate: getYesterdayDate(),
      finalDate: getYesterdayDate(),
      maxAllowedDate: getYesterdayDate(),
      veripag: null,
      ediRede: null,
      pending: null,
      gateway: null,
      gatewayData: [],
      receiptData: {
        veripag: { gross_amount: 0, not_conciliated: 0 },
        rede: { gross_amount: 0, not_conciliated: 0 },
        processing_or_pending: { processing: 0, pending: 0 },
        outOfDate: { gross_amount: 0 },
        gateway: { gross_amount: 0, not_conciliated: 0 },
        paid_and_antecipated: { paid: 0, antecipated: 0 },
        othersStatus: { gross_amount: 0, transactions: [] },
        pix: {
          veripag: { gross_amount: 0, not_conciliated: 0 },
          itau: { gross_amount: 0, not_conciliated: 0 },
          gsurf: { gross_amount: 0, not_conciliated: 0 },
        },
      },

      selectedTable: null,
      tableContent: [],
    };
  },
  watch: {
    selectedTable(newVal, oldVal) {
      if (!oldVal || !this.$refs.dataTable) return;

      const baseNew = newVal.split(" - ")[0];
      const baseOld = oldVal.split(" - ")[0];

      if (baseNew !== baseOld) {
        this.$nextTick(() => {
          this.$refs.dataTable.resetFilter();
        });
      }
    },
  },
computed: {
  tableMap() {
    return {
      "Veripag": this.veripagResume,
      "EDI REDE": this.ediRedeResume,
      "Veripag - Não Conciliados": this.veripagNotConciliated,
      "EDI REDE - Não Conciliados": this.ediRedeNotConciliated,
      "Processando": this.processingResume,
      "Processando - Transações": this.processingTransactions,
      "Gateway - GSurf": this.gsurfResume,
      "Gateway - GSurf - Não Conciliados": this.gsurfNotConciliated,
      "Gateway - PayGo": this.paygoResume,
      "Gateway - PayGo - Não Conciliados": this.paygoNotConciliated,
      "Fora de data": this.receiptData.outOfDate.transactions || [],
      "Estabelecimentos": this.receiptData.establishment || [],
      "Outros status": this.othersStatusResume,
      "PIX": this.pixResume,
      "PIX - Veripag - Não Conciliados": this.pixNotConciliatedVeripag,
      "PIX - Itaú - Não Conciliados": this.pixNotConciliatedItau,
      "PIX - GSurf - Não Conciliados": this.pixNotConciliatedGsurf,
    };
  }
},
  methods: {
    async handleSearch() {
      if (this.finalDate < this.initialDate) {
        this.searchError =
          "A data final não pode ser menor que a data inicial.";
        this.isLoading = false;
        return;
      }

      try {
        this.isLoading = true;
        this.searchError = null;
        const yesterday = getYesterdayDate();

        if (this.initialDate > yesterday || this.finalDate > yesterday) {
          this.searchError =
            "Os valores da data de hoje ainda não foram conciliados. Por favor, selecione outra data.";
          this.isLoading = false;
          return;
        }

        const response = await ConciliationEdiRedeService.getInfo({initialDate: this.initialDate,finalDate: this.finalDate});

        const veripag = response.data.veripag;
        const pix = response.data.pix || {};
        const rede = response.data.rede;
        const processing = response.data.processing_or_pending;
        const gateway = response.data.gateway;
        const gatewayData = response.data.gateway;

        this.processingTransactions = processing.transactions_processing_or_pending || [];
        this.receiptData = response.data;
        this.processingRaw = processing;
        this.veripagRaw = veripag;
        this.ediRedeRaw = rede;
        this.gsurfRaw = gateway.gsurf;
        this.paygoRaw = gateway.paygo;
        const others = response.data.othersStatus;

        this.othersStatusResume = [
          { label: "Total", value: others.gross_amount },
          { label: "POS", value: others.pos },
          { label: "TEF", value: others.tef },
          { label: "E-commerce", value: others.ecommerce },
          { label: "Quantidade", value: others.quantity },
        ];

        this.gsurfResume = [
          { label: "Total Bruto", value: gateway.gsurf.gross_amount },
          { label: "Não consta na veripag:",value: gateway.gsurf.gross_amount_not_in_veripag },
        ];

        this.paygoResume = [
          { label: "Total Bruto", value: gateway.paygo.gross_amount },
          { label: "Não consta na veripag:", value: gateway.paygo.gross_amount_not_in_veripag },
        ];

        this.pixResume = [
          {
            label: "Total Bruto",
            veripag: pix.veripag?.gross_amount || 0,
            itau: pix.itau?.gross_amount || 0,
            gsurf: pix.gsurf?.gross_amount || 0,
          },
          {
            label: "Não Conciliado (R$)",
            veripag: pix.veripag?.not_conciliated || 0,
            itau: pix.itau?.not_conciliated || 0,
            gsurf: pix.gsurf?.not_conciliated || 0,
          },
          {
            label: "Qtd. Não Conciliado",
            veripag: pix.veripag?.quantity_not_conciliated || 0,
            itau: pix.itau?.quantity_not_conciliated || 0,
            gsurf: pix.gsurf?.quantity_not_conciliated || 0,
          },
        ];
        this.veripagResume = [
          { label: "Total Bruto", value: veripag.gross_amount },
          { label: "Não Conciliado (R$)", value: veripag.not_conciliated },
          { label: "E-commerce", value: veripag.ecommerce },
          { label: "POS", value: veripag.pos },
          { label: "TEF", value: veripag.tef },
          { label: "Qtd. Não Conciliado",  value: veripag.quantity_not_conciliated },
        ];

        this.ediRedeResume = [
          { label: "Total Bruto", value: rede.gross_amount },
          { label: "Não Conciliado (R$)", value: rede.not_conciliated },
          { label: "Qtd. Não Conciliado",  value: rede.quantity_not_conciliated },
        ];

        this.processingResume = [
          { label: "Em Processamento", value: processing.processing },
          { label: "Pendentes", value: processing.pending },
          { label: "Total", value: processing.total },
        ];

        this.pixNotConciliatedVeripag =  pix.veripag?.transaction_not_conciliated || [];
        this.pixNotConciliatedItau =  pix.itau?.transaction_not_conciliated || [];
        this.pixNotConciliatedGsurf = pix.gsurf?.transaction_not_conciliated || [];
        this.gsurfNotConciliated = gateway.gsurf.transaction_not_conciliated || [];
        this.paygoNotConciliated = gateway.paygo.transaction_not_conciliated || [];
        this.veripagNotConciliated = veripag.transaction_not_conciliated;
        this.ediRedeNotConciliated = rede.transaction_not_conciliated;

        this.tableContent = this.veripagResume;
        this.gatewayData = gatewayData;
        this.openTable("Veripag");
        this.pix = Number(pix.itau?.gross_amount || 0);
        this.veripag = Number(veripag.gross_amount);
        this.ediRede = Number(rede.gross_amount);
        this.pending = Number(processing.total);
        this.gateway = Number(gateway.gross_amount);
      } catch (error) {
        console.error("Erro ao buscar informações:", error);
        this.searchError = "Não foi possível buscar os dados.";
      } finally {
        this.isLoading = false;
      }
    },

  openTable(name) {
    this.selectedTable = name;
    this.tableContent = this.tableMap[name] || [];
  },

    openNotConciliated(title) {
      const redirectMap = {
        "PIX - Veripag": "PIX - Veripag - Não Conciliados",
        "PIX - Itaú": "PIX - Itaú - Não Conciliados",
        "PIX - GSurf": "PIX - GSurf - Não Conciliados",
        "Veripag": "Veripag - Não Conciliados",
        "EDI REDE": "EDI REDE - Não Conciliados",
        "Processando": "Processando - Transações",
        "GSurf": "Gateway - GSurf - Não Conciliados",
        "PayGo": "Gateway - PayGo - Não Conciliados",
      };

      const match = Object.keys(redirectMap).find(key =>
        title.includes(key)
      );

      if (match) {
        this.openTable(redirectMap[match]);
        return;
      }

      if (title.includes("Outros status")) {
        this.selectedTable = "Outros status";
        this.tableContent =
          this.receiptData.othersStatus.transactions || [];
      }
    },

    async handleSend() {
      if (this.finalDate < this.initialDate) {
        this.$bvToast.toast("A data final não pode ser menor que a inicial.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
          autoHideDelay: 4000,
        });
        return;
      }

      try {
        this.sendingArchives = true;

        const response = await ConciliationEdiRedeService.sendAllConciliations({initialDate: this.initialDate,finalDate: this.finalDate});

        this.$bvToast.toast("Arquivos enviados com sucesso!", {
          title: "Envio Concluído",
          variant: "success",
          solid:true,
          autoHideDelay: 4000,
        });

      } catch (error) {
        console.error(error);

        this.$bvToast.toast("Erro ao enviar arquivos.", {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 4000,
        });

      } finally {
        this.sendingArchives = false;
      }
    },

  backToResume() {
    const baseMap = {
      "PIX": "PIX",
      "Veripag": "Veripag",
      "EDI REDE": "EDI REDE",
      "GSurf": "Gateway - GSurf",
      "PayGo": "Gateway - PayGo",
      "Processando": "Processando",
      "Outros status": "Outros status",
    };

    const match = Object.keys(baseMap).find(key =>
      this.selectedTable.includes(key)
    );

    if (match) {
      this.openTable(baseMap[match]);
    }
  },

    openTransactionDetails(item) {
      this.selectedTransaction = item;
      this.$bvModal.show("details-modal");
    },

    async generateExcelStyled() {
      if (this.isExporting) return;

      try {
        this.isExporting = true;
        await generateConciliationExcel({
          initialDate: this.initialDate,
          finalDate: this.finalDate,
          receiptData: this.receiptData,
        });
      } catch (error) {
        console.error("Erro ao gerar Excel:", error);
        this.$bvToast.toast("Não foi possível gerar o arquivo Excel.", {
          title: "Erro na exportação",
          variant: "danger",
          solid: true,
          autoHideDelay: 4000,
        });
      } finally {
        this.isExporting = false;
      }
    },

    startTour() {
      startDashboardTour();
    },
    openConfirmModal() {
      this.$bvModal.show("confirm-check-modal");
    },
    confirmSendFiles() {
      this.handleSend();
    }

  },
};
</script>

<style scoped>
.tour-icon-btn {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 0;
  margin-bottom: 10px;
}

.tour-icon-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.dotted-spinner {
  width: 22px;
  height: 22px;
  border: 3px dotted #fff;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.search-error {
  color: #dc3545;
  font-size: 14px;
  margin-top: 8px;
  margin-left: 4px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.no-table-selected {
  min-height: 260px; 
  border: 1px dashed #e6e6e6;
  border-radius: 8px;
  background: #ffffff;
  padding: 24px;
  color: #6b6b6b;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.no-table-selected .fa-table {
  color: #adb5bd;
}

@media (max-width: 576px) {
  .no-table-selected {
    min-height: 180px;
    padding: 16px;
  }
}
</style>
